import { render, staticRenderFns } from "./TrafficInfo.vue?vue&type=template&id=fe5ca410&scoped=true&"
import script from "./TrafficInfo.vue?vue&type=script&lang=js&"
export * from "./TrafficInfo.vue?vue&type=script&lang=js&"
import style0 from "./TrafficInfo.vue?vue&type=style&index=0&id=fe5ca410&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe5ca410",
  null
  
)

export default component.exports